// removed by extract-text-webpack-plugin
module.exports = {"Footer":"_268PTvg9wQahr3U8ATVz95","content":"_2oleg0L8BdBbzu7EHfbAwg","contentShow":"hYqzMYW1wguAY-EN72S-3 _2oleg0L8BdBbzu7EHfbAwg","firstCol":"_1QzzwG56y_zDJGV_eNYveS","menuList":"JtV5TH0RxYK3NkmxQEcDt","menuListItem":"_1f2QKHDHgYChdELnfbYU74","addressLinks":"lIawja4eEKBoIbGclUxh0","smk":"_3Lt0S64jC2-4JDqa2EHy4r","logos":"_152NIZBYbq7HIu3Yg64OM3","donutSpinner":"_1VjY37649ExtspWbg00Xbb","donut-spin":"_3hboEfiiQ9YM7BOPPDaWHC","menuListSecondary":"lHgNiVPqwYNjWMJq2VazJ","menuListItemSecondary":"_1wkhkn-Jr__oGAGB0xQnrt","footerForm":"_26vvtGjOnxDjUgTgQrUy4G"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.css
// module id = 280
// module chunks = 8